import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {SoVanThuService} from '../../../service/info/service-sovanthu';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {UsersService} from '../../../service/staff/service-users';
import {GroupSelectComponent} from '../group/groupselect.component';
import {GroupUserDefine} from '../../../models/staff/groupuserdefine';
import {GroupUserDefineService} from '../../../service/staff/service-groupuserdefine';
import {GroupStaffsService} from '../../../service/staff/service-groupstaffs';
import {GroupStaffs} from '../../../models/staff/groupstaffs';
import {Users} from '../../../models/staff/users';
import {CommandUtil} from '../../../global/commandutil';
@Component({
  templateUrl: './reg.component.html'

})export class RegUserComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  public isEdit: boolean = false;
  public submitValidate = false;
  public dataRoles: GroupUserDefine[] = [];
  public onClose: Subject<boolean>;
  public staffSingerList: Object[]=[];
  public selectedSingerList: Object[]=[];
  public checked: boolean = false;
  public dataCheck: Object[]=[];
  public userItem: Users = new Users();
  constructor( public usersService: UsersService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public commandUtil: CommandUtil,
               public groupUserDefineService: GroupUserDefineService,
               public groupStaffsService: GroupStaffsService
  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      userName: new FormControl(),
      matKhau: new FormControl(),
      matKhau1: new FormControl(),
      staffID: new FormControl('0')


    });
    this.frmGroup = this.formBuilder.group({
      userName: ['' , Validators.compose([validateEmpty]) ],
      matKhau: ['' , Validators.compose([validateEmpty]) ],
      matKhau1: ['' , Validators.compose([validateEmpty]) ],
      staffID: ['', Validators.nullValidator],
      id: ['', Validators.nullValidator]
    });
    this.groupUserDefineService.getAll().subscribe(data=> this.dataRoles =data);
  }
  public checkAll(event)
  {
    this.dataCheck=[];
    this.checked= event.target.checked;
    if(event.target.checked == true)
    {
      for(let i=0;i< this.dataRoles.length;i++)
        this.dataCheck.push(this.dataRoles[i].id);
    }
  }
  public checkedItem(event)
  {

    if(event.target.checked== true && this.dataCheck.indexOf(event.target.value) ==-1)
      this.dataCheck.push(event.target.value);
    else
       this.commandUtil.removeItem(event.target.value, this.dataCheck);
    if(this.dataCheck.length==0)
      this.checked=false;
  }
  public showSinger()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-lg'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSingerList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null && result.length >= 1)
      {
        if(this.staffSingerList.some(e => e["id"] === result[0].id)==false) {
          this.staffSingerList= [...this.staffSingerList, {id: result[0].id, fullName: result[0].fullName}];
          this.selectedSingerList= [...this.selectedSingerList, result[0].id];
        }
      }
    });
  }

  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    this.id = id;
    this.isEdit = id != 0 ? true: false;
    this.usersService.getById(id).pipe(first())
      .subscribe(x => {
        this.frmGroup.patchValue(x);
        this.userItem = x;
        if(x.staffItem!=null)
        {
          this.staffSingerList= [...this.staffSingerList, {id: x.staffID, fullName: x.staffItem.fullName}];
          this.selectedSingerList= [...this.selectedSingerList, x.staffID];
        }
        this.groupStaffsService.findByStaffId(x.staffID).subscribe(y => {
              for(let k=0; k< y.length;k++)
                this.dataCheck.push(y[k].groupID);
          });
        });
  }
  public loadChecked(id: number): boolean
  {
    return this.dataCheck.findIndex(x=>Number(x) == id)!=-1;
  }
  createItem ()
  {
    this.userItem.staffID= Number(this.selectedSingerList[0]);
    this.userItem.id = this.id;
    this.userItem.userName = this.frmGroup.value.userName;
    this.userItem.password = this.frmGroup.value.matKhau;

    this.usersService.add(this.userItem).subscribe({
      next: (data) => {
        if(data.id!=0) {
          this.groupStaffsService.insertMultiGroup(data.staffID, this.dataCheck.join()).subscribe(
            { next : (ds) =>
              {
                this.toastr.success(language.update_success_record, language.message);
                this.onConfirm();
              },
              error: error => {
                this.toastr.error(language.error, language.message);
              }
            });
        }else
        {
          this.toastr.error(language.error_username_exists, language.message);
        }
      },
      error: error => {
        this.toastr.error(language.error_username_exists, language.message);
      }
    });
  }
  updateItem()
  {
    this.userItem.staffID= Number(this.selectedSingerList[0]);
    this.userItem.id = this.id;
    this.userItem.userName = this.frmGroup.value.userName;
    this.userItem.password = this.frmGroup.value.matKhau;
    this.usersService.update(this.userItem).subscribe({
      next: (data) => {
        if(data.id!==0) {
          this.groupStaffsService.insertMultiGroup(data.staffID, this.dataCheck.join()).subscribe();
          this.toastr.success(language.update_success_record, language.message);
          this.onConfirm();
        }else
          this.toastr.error(language.error_username_exists, language.message);
      },
      error: error => {
        this.toastr.error(language.error_username_exists, language.message);
      }
    });
  }
  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if(this.frmGroup.value.matKhau!= this.frmGroup.value.matKhau1)
    {
      this.toastr.error(language.nhaplaimatkhau_error, language.message);
      return;
    }

    if (this.isEdit)
      this.updateItem();
    else
      this.createItem();
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
